import { FrameDTO } from '@/features/demo/dto/FrameDTO';

export enum PositionType {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP_LEFT = 'TOP_LEFT',
  TOP_RIGHT = 'TOP_RIGHT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  LEFT_TOP = 'LEFT_TOP',
  LEFT_BOTTOM = 'LEFT_BOTTOM',
  RIGHT_TOP = 'RIGHT_TOP',
  RIGHT_BOTTOM = 'RIGHT_BOTTOM'
}

export enum FrameTooltipType {
  HOTSPOT = 'HOTSPOT',
  TOOLTIP = 'TOOLTIP'
}

export enum NextStepButtonType {
  ELEMENT = 'ELEMENT',
  BUTTON = 'BUTTON'
}

export interface FrameTooltipDTO {
  id: string;
  hasTitle: boolean;
  titleSize: number;
  title?: string;
  hasDescription: boolean;
  description?: string | null;
  backgroundColor: string;
  width: number;
  height: number;
  frame: FrameDTO;
  frameId: string;
  order: number;
  deleted?: boolean;
  type: FrameTooltipType;
  borderColor?: string;
  x?: number;
  y?: number;
  targetX?: number;
  targetY?: number;
  borderRadius?: number;
  borderWidth?: number;
  highlight?: boolean;
  highlightColor?: string;
  positionType?: PositionType;
  hideTargetAfterAnimation?: boolean;
  hasNextButton?: boolean;
  hasPreviousButton?: boolean;
  nextButtonColor?: string;
  nextButtonTextColor?: string;
  previousButtonColor?: string;
  counterColor?: string;
  show?: boolean;
  isBottomFixed: boolean;
  paths?: any[];
  nextStepButtonType?: NextStepButtonType;
  dimBackground?: boolean;
}
